// extracted by mini-css-extract-plugin
export default {"container":"kn-z","blurb":"ln-z","links":"mn-z"};